const styles = {
  global: {
    body: {
      fontFamily: '',
      color: '',
    },
    // Solves a bug where "base" style is not applied
    '.chakra-modal__content': {
      '@media screen and (max-width: 47.999em)': {
        maxWidth: '100% !important',
      },
    },
    // Adds input label floating and animated
    '.chakra-form-control': {
      position: 'relative',
      '.chakra-input:not(:placeholder-shown) + .chakra-form__label, .chakra-numberinput__field:not(:placeholder-shown) + .chakra-form__label, .chakra-select__wrapper + .chakra-form__label':
        {
          bg: 'white',
          borderRadius: '5px',
          color: 'gray.500',
          fontSize: '11px',
          opacity: 1,
          px: 1,
          py: 0,
          transform: 'translateY(-13px)',
          zIndex: 100,
        },
      '.chakra-form__label': {
        fontSize: '16px',
        left: '10px',
        opacity: 0,
        position: 'absolute',
        top: '13%',
        transition: 'all 0.3s ease',
      },
    },
    // In order to set the distance from the top on the toast
    '#chakra-toast-manager-top': {
      'z-index': '16000 !important',
      '@media screen and (min-width: 48em)': {
        top: '3.5em !important',
      },
    },
    '#chakra-toast-manager-bottom': {
      'z-index': '16000 !important',
    },
    '.chakra-select__icon-wrapper': {
      fontSize: '20px !important',
      width: '20px !important',
    },
    '.react-datepicker': {
      fontSize: '1.4rem',
    },
    '.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name':
      {
        width: '2.6rem',
        lineHeight: '2.6rem',
      },
  },
};

export default styles;
